<template>
    <div>
        <template v-if="!wapShow">
            <header-hove :tab-index="3"></header-hove>
            <div style="padding: 0 50px;background: #ffffff;text-align: left">
            <span class="crumbs">
				<span @click="btn_buto()" style="cursor: pointer;">首页</span>
				><span @click="btn_buso()" style="cursor: pointer;">资讯与动态</span>
				><span v-if='obj.type==2' @click="btn_buao(obj.type)" style="cursor: pointer;">公司动态</span>
				<span v-if='obj.type==1' @click="btn_buao(obj.type)" style="cursor: pointer;">行业资讯</span>
				>
				<span style="font-weight: bold">{{obj.title}}</span>
				</span>
                <div v-html="obj.htmls" id="details"></div>
            </div>
            <footers></footers>
        </template>
        <template v-else>
            <information-wap-detail></information-wap-detail>
        </template>
    </div>
</template>

<script>
    import HeaderHove from "../../components/headerHove";
    import Footers from "../../components/footer";
    import eventBus from "@/assets/js/eventBus";
    import informationWapDetail from "./wap/detail.vue"
    export default {
        name: "detail",
        components: {Footers, HeaderHove,informationWapDetail},
        data(){
          return{
              obj:{htmls:''},
              wapShow:false,
          }
        },
        mounted() {
            this.getData(this.$route.query.id);
            if(this.$route.query) this.wapShow = this.$route.query.wapShow;
            eventBus.$on("wapShow",(data)=>{
                this.wapShow= data;
            })
        },
        methods:{
			btn_buto() {
				this.$router.push('/')
			},
			btn_buso() {
				this.$router.push('/InformationDynamics')
			},
			btn_buao(type) {
				this.$router.push('/InformationDynamics?type='+type)
			},
            getData(id){
                    const newEnergy = this.newEnergy = require('../../assets/JSONData/Information/company.json');
                    const nitrileCompound = this.nitrileCompound = require('../../assets/JSONData/Information/InformationDynamics.json');
                    let list = [];
                    list = list.concat(newEnergy);
                    list = list.concat(nitrileCompound)
                    for (let i in list) {
                        if (list[i].id == id) {
                            this.obj = list[i];
                        }
                    }
            }
        }
    }
</script>

<style scoped>

    .crumbs {
        text-align: left;
        display: block;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #3A3A3A;
        padding-bottom: 28px;
    }
</style>
